var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-sidebar-wrapper" }, [
    _c("div", { staticClass: "page-sidebar navbar-collapse collapse" }, [
      _c(
        "ul",
        {
          staticClass:
            "page-sidebar-menu page-sidebar-menu-hover-submenu sidebar-menu-ul"
        },
        _vm._l(_vm.menu, function(item, key) {
          return _c(
            "li",
            {
              key: key,
              class: {
                active: item.active && item.active.indexOf(_vm.route) !== -1
              }
            },
            [
              _c("router-link", { attrs: { to: { name: item.name } } }, [
                _c("i", { class: item.icon }),
                _vm._v(" "),
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(item.title))
                ]),
                _vm._v(" "),
                item.sub ? _c("span", { staticClass: "arrow" }) : _vm._e()
              ]),
              _vm._v(" "),
              item.sub
                ? _c(
                    "ul",
                    { staticClass: "sub-menu" },
                    _vm._l(item.sub, function(sub_item) {
                      return _c(
                        "li",
                        { key: sub_item.name },
                        [
                          _c(
                            "router-link",
                            { attrs: { to: { name: sub_item.name } } },
                            [_vm._v(_vm._s(sub_item.title))]
                          )
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e()
            ],
            1
          )
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a77b2c7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a77b2c7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Side.vue
// module id = null
// module chunks = 